import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// 考试模版浏览
export async function previewExamTemp(params: { id: string }) {
  return Http.get(`/api/v1/exam/previewTemp${judgeIsSplice()}`, params);
}
// 获取考试
export async function getExamPaper(params: any) {
  return Http.get(`/api/v1/exam/getPaper${judgeIsSplice()}`, params);
}
// 提交答案
export async function submitExamAnswer(params: any) {
  return Http.post(`/api/v1/exam/answer${judgeIsSplice(true)}`, params);
}
// 提交试卷
export async function submitExam(params: { examID: string, user_id: string }) {
  return Http.post(`/api/v1/exam/submit${judgeIsSplice(true)}`, params);
}
// 添加棋子
export async function addFlag(params: any) {
  return Http.post(`/api/v1/exam/addFlag${judgeIsSplice(true)}`, params);
}
// 删除棋子
export async function removeFlag(params: any) {
  return Http.post(`/api/v1/exam/removeFlag${judgeIsSplice(true)}`, params);
}
// 添加星标
export async function addStar(params: any) {
  return Http.post(`/api/v1/exam/addStar${judgeIsSplice(true)}`, params);
}
// 删除星标
export async function removeStar(params: any) {
  return Http.post(`/api/v1/exam/removeStar${judgeIsSplice(true)}`, params);
}
// 获取客户端考试记录详情
export async function getExamRecord(params: { id: string }) {
  return Http.get(`/api/v1/exam/getRecord${judgeIsSplice()}`, params);
}
// 获取管理端考试记录详情
export async function getAdminExamRecord(params: { id: string }) {
  return Http.get(`/api/v1/exam/m/getRecord${judgeIsSplice()}`, params);
}

// 修改考试记录
export async function updateRecord(params: any) {
  return Http.post(`/api/v1/exam/updateRecord${judgeIsSplice()}`, params);
}
// 获取考试记录列表
export async function getListRecord(params: any) {
  return Http.get(`/api/v1/exam/listRecord${judgeIsSplice()}`, params);
}
// -----------------------------  试卷库  -------------------------
// 获取人员信息
export async function getUserInfo(params: any) {
  return Http.get(`/api/v1/exam/getUser${judgeIsSplice()}`, params);
}
// 获取人员信息
export async function checkExam(params: any) {
  return Http.get(`/api/v1/exam/check${judgeIsSplice()}`, params);
}


// 反馈考试环境问题
export async function submitExamEnvFeedback(params: any) {
  return Http.post(`/api/v1/exam/feedback/create${judgeIsSplice()}`, params);
}


// 获取反馈详情
export async function getExamEnvFeedbackDetail(params: any) {
  return Http.get(`/api/v1/exam/feedback/get${judgeIsSplice()}`, params);
}


// 反馈考试体验
export async function submitExamExpFeedback(params: any) {
  return Http.post(`/api/v1/exam/evaluate/create${judgeIsSplice()}`, params);
}


// 获取人员考试结果
export async function getUserAutoExamGrade(params: any) {
  return Http.get(`/api/v1/exam/getUserGrade${judgeIsSplice()}`, params);
}


export async function uploadFile(params: any) {
  return Http.post(`/api/v1/exam/knowledge/upload${judgeIsSplice()}`, params);
}

// 获取评价详情
export async function getEvaluateDetail(params: any) {
  return Http.get(`/api/v1/exam/evaluate/get${judgeIsSplice()}`, params);
}


// 获取人员考试结果
export async function getUserGrade(params: any) {
  return Http.get(`/api/v1/exam/getUserGrade${judgeIsSplice()}`, params);
}


// 发送人员考试结果
export async function sendGrade(params: any) {
  return Http.post(`/api/v1/exam/sendGrade${judgeIsSplice()}`, params);
}

// 获取邮件详情
export async function getNoticeDetail(params: any) {
  return Http.get(`/api/v1/exam/notice/get${judgeIsSplice()}`, params);
}

